import React, { useEffect } from "react";
import Typewriter from "typewriter-effect";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import bannerMbaba from "../../Images/new/mbaba-bannerBg.png";
const Banner = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
  }, []);

  return (
    <div>
      <div className="bg-gradient-to-r from-sky-500 from-30% via-indigo-600 via-90% to-sky-500 to-10%">
        <div
          className="hero min-h-16  py-14"
          style={{
            backgroundImage: `url(${bannerMbaba})`,
          }}
        >
          <div
            className="hero-content text-center text-neutral-content  max-w-7xl mx-auto px-1"
            style={{ fontFamily: "Galada" }}
          >
            <div data-aos="fade-down font-extrabold">
              <h1 className="mb-10 md:px-5 px-3 text-3xl md:text-5xl text-white tracking-wid">
                Mbaba - পণ্য হাতে পেয়ে মূল্য পরিশোধ করবেন!
                <br></br> 🌟 <br /> ৭২ ঘণ্টার মধ্যে সারা বাংলাদেশে হোম ডেলিভারি।
              </h1>
              <h2 className="mb-10 py-8 md:text-2xl text-lg px-5 text-white tracking-widest ">
                <Typewriter
                  options={{
                    strings: [
                      `<strong>যে কোনো দুইটি প্রোডাক্ট অর্ডার করলেই ডেলিভারি চার্জ ফ্রি। ১০০ % 
                  অরিজিনাল প্রডাক্ট এবং যে কোনো সমস্যায় শতভাগ সমাধানের নিশ্চয়তা।</strong> `,
                    ],
                    autoStart: true,
                    loop: true,
                  }}
                />
                <br></br>
              </h2>

              <Link to="/shops">
                <button
                  className="btn border-2 border-white shadow-2xl text-white bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500"
                  style={{ fontFamily: "Roboto" }}
                >
                  Find it now
                </button>{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
